export default {"src":"/_next/static/media/DASH.d9b5b47d.svg","height":18,"width":18};